module.exports = __webpack_public_path__ + "images/ten-year-club-35503e34f992e221c4715dc900ff46e8.png";